export const usmle2ModuleOverview = [
  {
    id: "internal",
    title: "Internal Medicine",
    description: "Core inpatient/outpatient management.",
    icon: "🩺",
    gradient: "from-emerald-100 via-teal-50 to-cyan-100 border-teal-300",
  },
  {
    id: "surgery",
    title: "Surgery",
    description: "Periop care and surgical emergencies.",
    icon: "🪡",
    gradient: "from-red-100 via-rose-50 to-pink-100 border-red-300",
  },
  {
    id: "peds",
    title: "Pediatrics",
    description: "Growth, vaccines, and pedi conditions.",
    icon: "🧸",
    gradient: "from-amber-100 via-yellow-50 to-orange-100 border-amber-300",
  },
  {
    id: "obgyn",
    title: "OB/GYN",
    description: "Pregnancy and women’s health.",
    icon: "🤰",
    gradient: "from-pink-100 via-rose-50 to-fuchsia-100 border-pink-300",
  },
  {
    id: "psych",
    title: "Psychiatry",
    description: "Mood, psychosis, and treatments.",
    icon: "🧠",
    gradient: "from-violet-100 via-purple-50 to-indigo-100 border-violet-300",
  },
  {
    id: "emergency",
    title: "Emergency",
    description: "ABCs and acute stabilization.",
    icon: "🚑",
    gradient: "from-sky-100 via-blue-50 to-indigo-100 border-blue-300",
  },
  {
    id: "ethics",
    title: "Ethics/Communication",
    description: "Consent, capacity, and counseling.",
    icon: "🗣️",
    gradient: "from-slate-100 via-gray-50 to-zinc-100 border-slate-300",
  },
  {
    id: "biostats",
    title: "Biostatistics",
    description: "Study design and interpretation.",
    icon: "📊",
    gradient: "from-lime-100 via-green-50 to-emerald-100 border-lime-300",
  },
];
